import { useEffect } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import isEqual from "lodash.isequal"
// const isEqual = require("lodash/isEqual")

const DatalayerVideo = props => {
  const getPercentageComplete = () => {
    // if block returned the percentage of played video for Vimeo and YouTube videos
    if (props?.videoProgress?.playedSeconds && props?.videoProgress?.length) {
      return (
        (props?.videoProgress?.playedSeconds / props?.videoProgress?.length) *
        100
      )

      // else if block returns percentage for Vidyard videos.
    } else if (props?.videoProgress?.playedPercentage) {
      return props?.videoProgress?.playedPercentage
    }
  }

  const pushToDataLayer = () => {
    if (typeof window !== "undefined") {
      // vidyard sends two datalayer pushes and this blocks it
      if (
        isEqual(window?.dataLayer?.slice(-1)?.[0], {
          event: "video",
          video_title: props?.videoProgress?.title
            ? props?.videoProgress?.title
            : props?.videoProgress?.name
            ? props?.videoProgress?.name
            : null,
          video_provider: props?.videoProgress?.type,
          video_action: !getPercentageComplete()
            ? "video not played"
            : getPercentageComplete() && getPercentageComplete() >= "99"
            ? "video complete"
            : "closed video",
          video_complete: getPercentageComplete() >= "99" ? true : false,
          video_percentage: getPercentageComplete()
            ? `${Math.trunc(getPercentageComplete())}%`
            : "video not played",
        })
      ) {
        return
      }

      // trigger datalayer push when video modal is closed
      window.dataLayer = window.dataLayer || []

      if (!props?.videoProgress?.title && !props?.videoProgress?.name) {
        return
      }

      window.dataLayer.push({
        event: "video",
        video_title: props?.videoProgress?.title
          ? props?.videoProgress?.title
          : props?.videoProgress?.name
          ? props?.videoProgress?.name
          : null,
        video_provider: props?.videoProgress?.type,
        video_action: !getPercentageComplete()
          ? "video not played"
          : getPercentageComplete() && getPercentageComplete() >= "99"
          ? "video complete"
          : "closed video",
        video_complete: getPercentageComplete() >= "99" ? true : false,
        video_percentage: getPercentageComplete()
          ? `${Math.trunc(getPercentageComplete())}%`
          : "video not played",
      })
    }
  }

  useEffect(() => {
    //send to datalayer on start of video
    if (
      props?.videoProgress?.played === 0 ||
      props?.videoProgress?.playedPercentage === 0
    ) {
      if (!props?.videoProgress?.title) {
        return
      }

      window.dataLayer.push({
        event: "video",
        video_title: props?.videoProgress?.title
          ? props?.videoProgress?.title
          : props?.videoProgress?.name
          ? props?.videoProgress?.name
          : null,
        video_provider: props?.videoProgress?.type,
        video_action: "video_start",
        video_complete: false,
        video_percentage: "0%",
      })
    }
    // send to datalayer on pause (this does not work for vidyard)
    if (
      props?.videoProgress?.video_action === "paused" &&
      props?.videoProgress?.played !== 0 &&
      getPercentageComplete()
    ) {
      if (!props?.videoProgress?.title) {
        return
      }
      window.dataLayer.push({
        event: "video",
        video_title: props?.videoProgress?.title
          ? props?.videoProgress?.title
          : props?.videoProgress?.name
          ? props?.videoProgress?.name
          : null,
        video_provider: props?.videoProgress?.type,
        video_action: "paused video",
        video_complete: false,
        video_percentage: `${Math.trunc(getPercentageComplete())}%`,
      })
    }

    // send to datalayer after a pause to tell datalayer the video has been resumed after a pause (again does not work for vidyard)
    if (
      props?.videoProgress?.video_action === "playing" &&
      props?.videoProgress?.playedSeconds > 0
    ) {
      if (!props?.videoProgress?.title) {
        return
      }
      window.dataLayer.push({
        event: "video",
        video_title: props?.videoProgress?.title
          ? props?.videoProgress?.title
          : props?.videoProgress?.name
          ? props?.videoProgress?.name 
          : null,
        video_provider: props?.videoProgress?.type,
        video_action: "video resumed after pause",
        video_complete: false,
        video_percentage: `${Math.trunc(getPercentageComplete())}%`,
      })
    }

    if (props?.videoProgress?.eventType?.target?.classList) {
      const transformedDOMnodeList = Array.from(
        props?.videoProgress?.eventType?.target?.classList
      )
    }
  }, [props])

  const datalayerVideoStartHandler = event => {
    if (event) {
      const transformedDOMnodeList = Array.from(event?.target?.classList)
      if (transformedDOMnodeList && transformedDOMnodeList?.length) {
        let youtubeVimeoElement = []
        transformedDOMnodeList.find(item => {
          if (item?.includes("luna-super-hero__close-button")) {
            pushToDataLayer()
          } else if (item?.includes("luna-super-hero__video-close-wrapper")) {
            pushToDataLayer()
          }
        })
      }
    }
  }

  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll(".luna-super-hero__play-btn").length > 0
    if (!query) {
      // this is to track for videos within a CTA
      query = document.querySelectorAll(".ter-button").length > 0
    }
  }
  useClickListener(datalayerVideoStartHandler, query)
}

export default DatalayerVideo
